import type { CarrierRow } from "design-components";

/** Matches customer list paging (`CUSTOMERS_LIST_PAGE_SIZE`). */
export const CARRIERS_LIST_PAGE_SIZE = 50;

export interface CarriersListState {
  rows: CarrierRow[];
  totalCarriers: number;
  loading: boolean;
  error: string | null;
  search: string;
  fromIndex: number;
  toIndex: number;
  sortingField: string;
  sortingOrder: "asc" | "desc";
  selectedOperatorIds: string[];
  selectedCustomerIds: string[];
  showOnlyActive: boolean;
  listFilterDotStatus: string[];
  listFilterRiskLevel: string[];
  listFilterAviroStatus: string[];
  listFilterLocationIds: string[];
  toolbarLocationFilterIds: string[];
}

export const carriersListInitialState: CarriersListState = {
  rows: [],
  totalCarriers: 0,
  loading: false,
  error: null,
  search: "",
  fromIndex: 0,
  toIndex: CARRIERS_LIST_PAGE_SIZE,
  sortingField: "carrierName",
  sortingOrder: "asc",
  selectedOperatorIds: [],
  selectedCustomerIds: [],
  showOnlyActive: true,
  listFilterDotStatus: [],
  listFilterRiskLevel: [],
  listFilterAviroStatus: [],
  listFilterLocationIds: [],
  toolbarLocationFilterIds: [],
};
